import React from 'react'

const Comingsoon = () => {
    let animationLines = [
        [
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
          "COMING SOON",
        ],
        [
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
        ],
        [
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
            "COMING SOON",
        ],
        
      ];
  return (
    <div className="bg-[#010101] flex flex-col flex-wrap justify-center md:flex-nowrap py- md:py-12 relative gap-4 overflow-hidden z-10 h-[100vh] w-[100vw] max-w-[1480px] mx-auto">
        <div className='w-full flex justify-center items-center'>
        <img src="../Asssets/AIMS.png" alt="" className='w-[300px] md:w-[500px]' />
        </div>

        {animationLines.map((user, index) => {
          return (
            <div
              className="text-3xl md:text-5xl font-extrabold  flex gap-8   transition-all duration-[2000ms] "
              key={index}
            >
              {user.map((user, indx) => {
                return (
                  <p
                    className={`whitespace-nowrap strokeText  cursor-pointer ${
                      index == 1
                        ? "moveleftfast"
                        : "moveright translate-x-[-800px]"
                    } `}
                    key={indx}>
                    {user}
                  </p>
                );
              })}
            </div>
          );
        })}
        <div className='w-full flex justify-center items-center '>
            <p className='border-[#e5a15f] border-b-2 text-white text-2xl  md:text-4xl font-bold max-w-[300px] mt-8'>
            STAY TUNED
            </p>
        </div>
      </div>
  )
}

export default Comingsoon